import isTypeOf from './isTypeOf';
var isString = isTypeOf('string');
export default isString;